export default "__VITE_ASSET__CR_ABD6s__"